import { render } from "./KSPaginationInfo.vue?vue&type=template&id=33f83cff"
import script from "./KSPaginationInfo.vue?vue&type=script&lang=js"
export * from "./KSPaginationInfo.vue?vue&type=script&lang=js"

import "./KSPaginationInfo.vue?vue&type=style&index=0&id=33f83cff&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__